<template>
	<div class="aboutCertificates">
		<my-header active="0" />
		<div class="main">
			<div class="container">
				<div class="current ">
					<p>当前位置：首页>{{positions}}</p>
				</div>
                <div class="warp sidebar-right">
                    <h1 v-if="data.name">{{data.name}}</h1>
                    <!-- <p></p> -->
                    <div class="mainText" v-html="data.content"></div>
                    <div class="file">
                        <a :href="item.fileUrl" v-for="item in data.files" target="_blank">{{ item.fileName }}</a>
                    </div>
                </div>
            </div>
        </div>   
    </div>
</template>

<script>
import pagination from '@/components/pagination'
import { fetchArticle } from '@/api/article'
import { noticeDetail } from '@/api/center'

export default {
	name: 'articleDetails',
	components: {
        pagination
	},
	data(){
		return {
            listQuery: {
				page: 1,
				limit: 20,
			},
            total:100,
            positions:'文章详情',
            type:null,
			data:{}
		}
	},
	mounted(){
        this.get()
    },
    methods:{
        get(){
            if(this.$route.query.type == 6){
                this.positions = '我的通知详情'
                noticeDetail({id:this.$route.query.id}).then(res=>{
                 console.log(res)
                 this.data=res.result
                })
            }else{
                fetchArticle({id:this.$route.query.id}).then(res=>{
                    this.data = res
                })
            }
    //         console.log(this.$route.query.type)
    //         this.type = this.$route.query.type
    //         if (this.type==1) {
    //             this.positions = '动态消息详情'
    //         }else if(this.type==2){
    //             this.positions = '项目介绍详情'
    //         }else if(this.type==3){
    //             this.positions = '证书介绍详情'
    //         }else if(this.type==4){
    //             this.positions = '考试公告详情'
    //         }else if(this.type==5){
    //             this.positions = '政策文件详情'
    //         }else if(this.type==6){
    //             this.positions = '我的通知详情'
				// noticeDetail({id:this.$route.query.id}).then(res=>{
				// 	console.log(res)
				// 	this.data=res.result
				// })
    //         }else if(this.type==7){
    //             this.positions = '关于证书详情'
    //         }else if(this.type==8){
    //             this.positions = '考试认证详情'
    //         }else if(this.type==9){
    //             this.positions = '考试公告详情'
    //         }
        },
		getList(){
			this.$message('获取列表')
		}
	}
}
</script>

<style scoped>
.warp{
    display: block;
}
.warp h1{
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
}
.warp p{
    padding: 10px 0;
}
.sidebar-right{
    min-height: 400px;
    padding-bottom: 200px;
    text-indent:2em;
}
.mainText{min-height: 200px;}
.file a{display: block;text-decoration: underline;}
</style>
